S.headerSearchlayer =
    {
        elements: {
            $clearInput: null,
            $close: null,
            $searchInput: null,
            $closeMenuFocus: null,
        },

        init()
        {
            this.initSearchLayer();
            this.closeSearchLayer();
            this.checkInput();
            this.keyTab();
        },

        keyTab()
        {
            this.elements.$searchInput.on('keydown', (e) =>
            {
                // escape
                if (e.keyCode === 27)
                {
                    this.elements.$close.click();
                    $('#button_menu').focus();
                    $('body').addClass('is-keyboard-focus');
                }
            });
        },

        checkInput()
        {
            this.elements.$searchInput.on('keyup', (e) =>
            {
                if ($(e.currentTarget).val() === '')
                {
                    this.elements.$clearInput.find('button').attr('tabindex', '-1');
                }
                else
                {
                    this.elements.$clearInput.find('button').removeAttr('tabindex');
                }
            });
        },

        initSearchLayer()
        {
            this.elements.$clearInput.on('click', () =>
            {
                this.elements.$searchInput.val('');
                this.elements.$searchInput.focus();
            });
        },

        closeSearchLayer()
        {
            this.elements.$close.on('click', () =>
            {
                // e.stopPropagation().preventDefault();

                if ($('#header').length > 0)
                {
                    // bei mobile offen
                    if ($('#header').hasClass('is-mobile-nav-open'))
                    {
                        S.header.closeMobileNav();
                    }

                    S.header.searchLayerClose();
                }
            });
        },
    };
